import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React, { useCallback, useMemo } from 'react';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Divider } from 'ui-components/components/divider';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Tooltip } from 'ui-components/components/tooltip';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { PaymentMethodPicker } from './payment-method-picker';
import { sourceString } from './payments-table-auctane-pay';
import Global from '../../../../../store/global-selectors';
import { WalletRegistrationOrUpdateButton } from '../../../../../wallet/components/wallet-registration-or-update-button';
import { useWallet } from '../../../../../wallet/hooks/use-wallet';
import { TRIAL_EXPIRED, CANCELLED } from '../../constants/account-issues';
import { usePaymentAndSubscriptionPageContext } from '../../context/payment-and-subscription-page-context';
import { useDeriveSubscriptionInfo } from '../../hooks/use-derive-subscription-info';
import { PageEvents, useTrackEvent } from '../../hooks/use-track-event';
import { paymentTableMessages } from '../../messages';
import style from '../../style.module.less';

export const WalletRow = () => {
  const { reloadData, isBillingInfoLoading } = usePaymentAndSubscriptionPageContext();
  const planInfo = useSelector(Global.selectSellerPlanInfo);
  const { accountIssueStatus } = useDeriveSubscriptionInfo(planInfo);
  const shouldDisableWalletInteractions = [TRIAL_EXPIRED, CANCELLED].includes(accountIssueStatus);

  const wallet = useWallet();
  const { isWalletRegistered } = wallet;

  const modalProps = useMemo(
    () => ({
      onClose: reloadData,
    }),
    [reloadData],
  );

  const trackWalletBillingClick = useTrackEvent(PageEvents.UDPATE_WALLET_BILLING_CLICK, sourceString);

  const onChange = useCallback(() => {
    trackWalletBillingClick();
    reloadData();
  }, [reloadData, trackWalletBillingClick]);

  return (
    <>
      <FlexRow className={style['payment-row']}>
        <div className={style['tooltip-wrapper']}>
          <Text className={style['payment-row-label']} type={TextType.Label} value={paymentTableMessages.shipstationBalance} />
          <Tooltip position='top' text={<FormattedMessage {...paymentTableMessages.shipstationBalanceTooltip} />}>
            <div className={style['menu-toggle-contents']}>
              <FontAwesomeIcon icon={faInfoCircle} />
            </div>
          </Tooltip>
        </div>
        <div>
          {isWalletRegistered ? (
            <PaymentMethodPicker
              disabled={shouldDisableWalletInteractions}
              onChange={onChange}
              transactionCategory={TransactionCategory.AddFunds}
            />
          ) : (
            <WalletRegistrationOrUpdateButton modalProps={modalProps} trackingId={sourceString}>
              {({ openModal: openWalletRegistrationModal }) => (
                <Button
                  disabled={shouldDisableWalletInteractions || isBillingInfoLoading}
                  onClick={openWalletRegistrationModal}
                  theme={THEME_CONSTANTS.tertiary}
                >
                  <FormattedMessage {...paymentTableMessages.activateAccount} />
                </Button>
              )}
            </WalletRegistrationOrUpdateButton>
          )}
        </div>
      </FlexRow>
      <Divider className={style.divider} />
    </>
  );
};
